function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2-en{fill:#fff}.cls-3{fill:#c00}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "en-rect124",
  fill: "#006",
  d: "M0 0H20.446V15.334H0z",
  transform: "translate(.001)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "en-g584"
}, /*#__PURE__*/React.createElement("path", {
  id: "en-path146",
  d: "M0 0v1.714l18.161 13.62h2.286V13.62L2.286 0H0zm20.447 0v1.714L2.286 15.334H0V13.62L18.161 0z",
  className: "cls-2-en"
}), /*#__PURE__*/React.createElement("path", {
  id: "en-path136",
  d: "M8.52 0v15.334h3.408V0zM0 5.111v5.111h20.447V5.111z",
  className: "cls-2-en"
}), /*#__PURE__*/React.createElement("path", {
  id: "en-path141",
  d: "M0 6.134V9.2h20.447V6.134zM9.2 0v15.334h2.045V0z",
  className: "cls-3"
}), /*#__PURE__*/React.createElement("path", {
  id: "en-path150",
  d: "M0 15.334l6.816-5.111H8.34l-6.816 5.111zM0 0l6.816 5.111H5.292L0 1.143V0zm12.107 5.111L18.923 0h1.524l-6.816 5.111zm8.34 10.223l-6.816-5.111h1.524l5.292 3.968z",
  className: "cls-3"
}));

var SvgEn = function SvgEn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "en-g578",
    width: 20.447,
    height: 15.334,
    viewBox: "0 0 20.447 15.334",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/en.15cb71ce.svg";
export { ForwardRef as ReactComponent };